module.exports = __webpack_public_path__ + "img/1779.5876bc6a.jpg";